import { CallAPI } from "@/util/GetAPIPermission";

export const CallAPI_Submission = async (id: string) => {
    const result = await CallAPI(`/submit-form/send-email-submission/${id}`, "POST");
    return result;
};
